import { Link } from '@reach/router';
import styled, { css } from 'styled-components';
import { withQuery } from '../data/withQuery';
import { Metafields, Product } from '@/types/ecommerce.types';
import { ProductOptionsTitle } from './ProductOptions.styles';
import { colors } from '@/themes/colorsMapping';
import { getMetafieldV2 } from '@/utils/utils';
import { getPartner } from '@/utils/partner';
import { navigate } from '@reach/router';

const StyledLink = styled(Link)<{ $availableToSell?: boolean }>`
  ${(props) =>
    !props.$availableToSell &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
  span {
    display: inline-block;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    text-align: center;
    width: 100%;
  }
`;
StyledLink.displayName = 'ColorSwatch';

const SwatchesList = styled.ul`
  padding: 3px;
  margin-top: 13px;
  position: relative;
  display: grid;
  list-style-type: none;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 5px;

  @media (min-width: 800px) {
    margin-top: 10px;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  li {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid ${colors.darkGray};
    &.tmplt-product__connected-collection-item--current {
      border-color: var(--color-primary);
      box-shadow: 0 0 0 3px var(--color-primary-20);

      span {
        color: ${colors.purple} !important;
      }
    }
  }
  a {
    background-color: transparent !important;
    background: none !important;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    padding: 0 0 10px 0;

    span {
      text-align: left;
      padding: 0 10px;
      @media (max-width: 800px) {
        display: block;
      }

    }
  }
  img {
    width: 100%;
    height: 70px;
    object-position: bottom;
    object-fit: cover;
  }
  .placeholder-img {
    height: 70px;
    width: 100%;
    background-color: #f1f0ec;
    background: linear-gradient(to right, #f1f0ec 0%, #ffffff 50%, #f1f0ec 100%);
    background-size: 800px 100%;
    animation: shimmer 1.5s infinite linear;
  }
  @keyframes shimmer {
    0% {
      background-position: -800px 0;
    }
    100% {
      background-position: 800px 0;
    }
  }
`;

type PropTypes = {
  product: Product;
  className: string;
  pagePath?: string;
  sectionTitle?: string;
  frameSize: string;  
};

const FamilyStyleOptions = ({
  product,
  className,
  pagePath = '/products',
  sectionTitle,
  frameSize,
}: PropTypes) => {
  interface productItem {
    colorCornerImg: string;
    currentProduct: boolean;
    productID: number;
    productHandle: string;
    productTitle: string;
  }
  const metafields = product?.metafields;
  const familyHallwayCollection = product?.product_family_hallway_collection?.reference;
  const currentProductTitle = getMetafieldV2('group_product_name', metafields);
  const partner = getPartner();

  const productItems: productItem[] =
    familyHallwayCollection?.products?.nodes?.map((item: any) => {
      let currentProduct = false;
      const productID = item?.id;
      const productHandle = item?.handle;
      const productTitle = item?.group_title?.value;
      const colorCornerImg = item?.color_image?.reference?.image?.url;

      if (product?.handle.toLowerCase() === productHandle.toLowerCase()) {
        currentProduct = true;
      }

      return {
        colorCornerImg: colorCornerImg,
        currentProduct: currentProduct,
        productID: productID,
        productHandle: productHandle,
        productTitle: productTitle,
      };
    }) || [];

  if (!product || !familyHallwayCollection || productItems.length === 0) return null;

  return (
    <div className={className}>
      {sectionTitle && (
        <ProductOptionsTitle>
          {sectionTitle}: {'\u00A0'}
          <span>{currentProductTitle}</span>
        </ProductOptionsTitle>
      )}
      <SwatchesList>
        {productItems?.map((item, index) => {
          return item?.productID ? (
            <li
              key={index}
              className={`product-option-color-item ${
                item?.currentProduct ? 'tmplt-product__connected-collection-item--current' : ''
              }`}             
            >
              <StyledLink
                $availableToSell={true}
                to={!item?.currentProduct ? `${pagePath}/${item?.productHandle}${frameSize ?? `?size=${frameSize}`}` : ''}
                title={item?.productTitle}
                onClick={() => {
                  if (!item?.productHandle) return;

                  const searchParams = new URLSearchParams();
                  searchParams.set('size', frameSize as string);
                  if (partner) {
                    searchParams.set('partner', partner);
                  }

                  const url = `/products/${item?.productHandle}?${searchParams.toString()}`;

                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  setTimeout(() => {
                    navigate(url);
                  }, 250);
                }}                 
              >
                {item?.colorCornerImg ? <img src={item?.colorCornerImg} alt="" /> : <div className="placeholder-img"></div>}
                <span className={'label'}>{item?.productTitle}</span>
              </StyledLink>
            </li>
          ) : null;
        })}
      </SwatchesList>
    </div>
  );
};

FamilyStyleOptions.displayName = 'ProductGallerySizes';
export default withQuery(FamilyStyleOptions);
